<div class="auth">
  @if (currMode === Mode.EnterEmail) {
    <div class="login-form">
      @if (emailConfirmFormGroup) {
        <form [formGroup]="emailConfirmFormGroup">
          <h3>{{ 'auth.enterEmail' | translate }}</h3>
          <div class="form-group">
            <label class="required">{{ 'auth.email' | translate }}</label>
            <dx-text-box valueChangeEvent="change keyup" formControlName="email"></dx-text-box>
            @if (displayRequiredError(emailConfirmFormGroup.get('email'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.required' | translate }}
              </div>
            }
            @if (
              emailConfirmFormGroup.get('email')?.dirty &&
              emailConfirmFormGroup.get('email')?.hasError('email')
            ) {
              <div class="ng-invalid-comment">
                {{ 'validation.validEmail' | translate }}
              </div>
            }
            @if (displayPatternError(emailConfirmFormGroup?.get('email'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.notAllowPlusSignInEmail' | translate }}
              </div>
            }
          </div>
          <div class="submit">
            <dx-button
              class="btn-xl btn-rounded"
              stylingMode="contained"
              type="default"
              text="{{ 'auth.sendConfirmation' | translate }}"
              (onClick)="onEmailConfirmationSubmit()">
            </dx-button>
          </div>
        </form>
      }
    </div>
  }

  @if (currMode === Mode.EnterCode) {
    <div class="login-form">
      @if (verificationCodeFormGroup) {
        <form [formGroup]="verificationCodeFormGroup">
          <h3>{{ 'auth.enterCode' | translate }}</h3>
          <div class="acenter">
            <img src="/assets/images/sent-success.png" class="sent-success" />
          </div>
          <div class="desc">
            {{ 'auth.codeEmailSent' | translate }}
            {{ emailConfirmFormGroup.get('email').value }}
          </div>
          <div class="form-group">
            <dx-text-box
              valueChangeEvent="change keyup"
              [maxLength]="6"
              formControlName="verificationCode"
              class="acenter">
            </dx-text-box>
            @if (displayRequiredError(verificationCodeFormGroup.get('verificationCode'))) {
              <div class="ng-invalid-comment">
                {{ 'validation.required' | translate }}
              </div>
            }
            <div class="small-desc">
              {{ 'auth.codeIsCaseSensitive' | translate }}
            </div>
          </div>
          <div class="submit">
            <dx-button
              class="btn-xl btn-rounded"
              stylingMode="contained"
              type="default"
              text="{{ 'auth.verify' | translate }}"
              (onClick)="onVerificationCodeSubmit()">
            </dx-button>
          </div>
        </form>
      }
    </div>
  }

  @if (currMode === Mode.SelectAccount) {
    <div class="login-form">
      @if (verificationCodeFormGroup) {
        <form [formGroup]="verificationCodeFormGroup" class="card-cont">
          <h3>{{ 'auth.selectAccount' | translate }}</h3>
          <div class="desc">
            {{ 'auth.selectAccountDesc' | translate }}
          </div>
          @if (clientsWithUser?.length > 0) {
            <div class="desc mtb20 fw500 main-links">
              {{ 'auth.forgotPasswordDesc' | translate }}
            </div>
          }
          @if (clientsWithUser?.length > 0) {
            <ul>
              @for (client of clientsWithUser; track client) {
                <li class="list-card list-card-line">
                  <a
                    href="javascript:void(0)"
                    class="flex-row list-card-link flex-row-justify-between grid-gap-10 cursor-pointer"
                    (click)="onSelectAction(NonceType.ForgottenPassord, client.ClientId)">
                    <div class="grid-row">
                      <div class="profile-images">
                        <div class="profile-images-photo">
                          <b>
                            {{ getShortName(client?.FullName) }}
                          </b>
                        </div>
                        <div
                          class="profile-images-right flex-row flex-row-direction-column justify-center align-flex-start">
                          <span>{{ client?.FullName }}</span>
                          <span class="item-desc-2">
                            {{ client.UserName }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <i class="icon-right-arrow"></i>
                  </a>
                </li>
              }
            </ul>
          }
          @if (clientsWithNoUser?.length > 0) {
            <div class="desc mtb20 fw500 main-links">
              {{ 'auth.completeClientDesc' | translate }}
            </div>
          }
          @if (clientsWithNoUser?.length > 0) {
            <ul>
              @for (client of clientsWithNoUser; track client) {
                <li class="list-card list-card-line">
                  <a
                    href="javascript:void(0)"
                    class="flex-row list-card-link flex-row-justify-between grid-gap-10 cursor-pointer"
                    (click)="
                      onSelectAction(NonceType.NewAccountForExistingClient, client.ClientId)
                    ">
                    <div class="grid-row">
                      <div class="profile-images">
                        <div class="profile-images-photo">
                          <b>
                            {{ getShortName(client?.FullName) }}
                          </b>
                        </div>
                        <div
                          class="profile-images-right flex-row flex-row-direction-column justify-center align-flex-start">
                          <span>{{ client?.FullName }}</span>
                        </div>
                      </div>
                    </div>
                    <i class="icon-right-arrow"></i>
                  </a>
                </li>
              }
            </ul>
          }
          <div class="desc mtb20 fw500 main-links">
            {{ 'general.or' | translate }}
          </div>
          <div class="acenter">
            <a
              href="javascript:void(0)"
              (click)="onSelectAction(NonceType.NewAccountAndClient)"
              class="simple-lnk"
              >{{ 'auth.newAccountDesc' | translate }}</a
            >
          </div>
        </form>
      }
    </div>
  }

  @if (canReturn) {
    <div class="form-footer">
      <a
        href="javascript:void(0)"
        class="simple-btn simple-btn-sm simple-btn-rounded simple-btn-dark-line"
        (click)="onBack()">
        <i class="icon-left-arrow"></i>
        <span>{{ 'general.back' | translate }}</span>
      </a>
    </div>
  }
</div>
